import GrowthHealth from '../sections/growthHealth/growthHealth';

export default function GrowthHealthPage() {
  return (
    <div className="section-page">
      <GrowthHealth />
    </div>
  );
}
